// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteConfirmModal_root__2mNHU","buttonGroup":"DeleteConfirmModal_buttonGroup__sFDjC"};